/**
 * Detect http(s) URLs in plain text for display as clickable links.
 * Trailing punctuation common in prose is excluded from the matched URL.
 */

const URL_PATTERN = /\bhttps?:\/\/[^\s<>"'{}|\\^`[\]]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)]+$/;

/**
 * @param {string} raw
 * @returns {{ url: string, trailing: string }}
 */
export function trimUrlMatch(raw) {
  const match = String(raw || '');
  const punct = match.match(TRAILING_PUNCTUATION);
  if (!punct) return { url: match, trailing: '' };
  return {
    url: match.slice(0, match.length - punct[0].length),
    trailing: punct[0],
  };
}

/**
 * Split text into plain and URL segments for rendering.
 * @param {unknown} text
 * @returns {Array<{ type: 'text' | 'url', value: string, href?: string }>}
 */
export function splitTextWithUrls(text) {
  const s = text == null ? '' : String(text);
  if (!s) return [];

  const segments = [];
  let lastIndex = 0;
  const re = new RegExp(URL_PATTERN.source, URL_PATTERN.flags);
  let m;
  while ((m = re.exec(s)) !== null) {
    if (m.index > lastIndex) {
      segments.push({ type: 'text', value: s.slice(lastIndex, m.index) });
    }
    const { url, trailing } = trimUrlMatch(m[0]);
    if (url) {
      segments.push({ type: 'url', value: url, href: url });
    }
    if (trailing) {
      segments.push({ type: 'text', value: trailing });
    }
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < s.length) {
    segments.push({ type: 'text', value: s.slice(lastIndex) });
  }
  return segments;
}
